import { Link, Outlet } from "react-router-dom";
import Menu from "../../../components/menu";
import Header from "../../../components/header";
import styles from "./style.module.css";

const logo = "/logo.png";

export default function UserLayout() {
  return (
    <div className={"d-flex bg-body"}>
      <div className="col-2 h-100 px-3 pb-3">
        <div className="text-center mb-3">
          <Link to="/">
            <img className="col-8 py-3" src={logo} alt="logo" />
          </Link>
        </div>
        <Menu />
      </div>
      <div className="col-10 h-100 ">
        <Header />
        <div className={"p-3 " + styles.rightSide}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
